<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mr3Gb0/tc-custom/9781685502324.jpg?1723950725111" alt="This image is the cover for the book Queer Relations, Twelve Letters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Queer Relations, Twelve Letters
      </h1>
      <p class="bookDescription body article font2">
        <p>Sequel to <i>Twelve Letters</i><br/><br/>In the autumn of 1814, the Honourable Percy Havilland is generally content with his sheltered existence in London’s exclusive Mayfair. As a society beau, renowned for his fair and youthful beauty and an object of desire to other well-born gentlemen, Percy is slightly miffed his personal life is not running as seamlessly as he might wish.<br/><br/>His good-natured lover from the spring season, Jo Everett, has inexplicably lost interest, and his replacement, Nathaniel Brooks, is far too hard-headed to be cajoled and manipulated into pandering to Percy’s every whim.<br/><br/>But these trifles are cast into proportion when, out of the blue, a family scandal of immense proportions threatens Percy’s peace of mind and his standing amongst the ton. Fearing rejection or even social banishment, to his surprise, Percy discovers a small, unconventional band of friends, including Jo, who are prepared to stick by him. And more importantly, he finds Nathan is utterly reliable in a crisis.<br/><br/>Will Percy remain spoiled, immature, and pampered? Or can he grow from this disaster to appreciate the value of true friendship? Might he even learn to love?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellie Thomas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63634340